import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, MenuItem, Avatar, IconButton, FormHelperText, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { useCreateEHSFindingMutation } from "store/slices/apis/ehsFindingApiSlice";
import CalenderSVG from "assets/logo/Calendar";
import { ptwIssuedOptions, stopWorkOptions, } from "helpers/ehsFindingOptions";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import CancelIcon from '@mui/icons-material/Cancel';


const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const MAX_TOTAL_SIZE = 30 * 1000 * 1000;

const AddEHSFinding = (props) => {
    const { open, handleClose } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const [createEHSFinding, { isLoading }] = useCreateEHSFindingMutation();

    const module = "EHSFinding";

    const { data: ehsContractorsRes } = useGetMasterDataQuery({ module: module, category: 'ContractorInvolved', ProjectId: projectId });
    const contractorData = ehsContractorsRes?.data || [];
    const contractorInvolvedOptions = mapAndSortAlphabetically(contractorData);

    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'StatusofCompliance', ProjectId: projectId });
    const { data: reportedByData } = useGetMasterDataQuery({ module: module, category: 'ReportedBy', ProjectId: projectId });
    const { data: categoryData } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: projectId });
    const { data: actionOwnerData } = useGetMasterDataQuery({ module: module, category: 'ActionOwner', ProjectId: projectId });
    const { data: verifiedByData } = useGetMasterDataQuery({ module: module, category: 'VerifiedBy', ProjectId: projectId });
    const { data: severityData } = useGetMasterDataQuery({ module: module, category: 'Severity', ProjectId: projectId });

    const statusOfComplianceOptions = statusData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const reportedByOptions = reportedByData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];


    const categoryOptions = categoryData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];


    const actionOwnerOptions = actionOwnerData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const verifiedByOptions = verifiedByData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const severityOptions = severityData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    }))?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const [formData, setFormData] = useState({
        dateTime: "",
        ehsFinding: "",
        reportedBy: "",
        recommendation: "",
        area: "",
        location: "",
        contractorSubContractorInvolved: "",
        category: "",
        ptwIssued: "",
        ptwIssuedBy: "",
        stopWorkRecommended: "",
        targetClosureDate: "",
        actionOwner: "",
        complianceStatement: "",
        verifiedBy: "",
        statusOfCompliance: "",
        severity: "",
        projectId: projectId,
        findingPhotographs: [],
        compliancePhotographs: []
    });

    const validationSchema = Yup.object({
        dateTime: Yup.date().required("Date field is required"),
        ehsFinding: Yup.string().required("EHS Finding field is required"),
        reportedBy: Yup.string().required("Reported By field is required"),
    });

    const validate = (values) => {
        const errors = {};

        const allFiles = [
            ...(values.findingPhotographs || []),
            ...(values.compliancePhotographs || [])
        ];

        const totalSize = allFiles.reduce((acc, file) => acc + file.size, 0);

        if (totalSize >= MAX_TOTAL_SIZE) {
            errors.findingPhotographs = "Total file size must be less than 30MB";
        }

        return errors;
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        // let reqBody = {
        //     projectId: projectId,
        //     dateTime: moment.utc(values?.dateTime, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
        //     ehsFinding: values?.ehsFinding,
        //     reportedBy: values?.reportedBy,
        //     recommendation: values?.recommendation,
        //     area: values?.area,
        //     location: values?.location,
        //     contractorSubContractorInvolved: values?.contractorSubContractorInvolved,
        //     category: values?.category,
        //     ptwIssued: values?.ptwIssued,
        //     ptwIssuedBy: values?.ptwIssuedBy,
        //     stopWorkRecommended: values?.stopWorkRecommended,
        //     targetClosureDate: values?.targetClosureDate
        //         ? moment.utc(values?.targetClosureDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]')
        //         : null,
        //     actionOwner: values?.actionOwner,
        //     complianceStatement: values?.complianceStatement,
        //     verifiedBy: values?.verifiedBy,
        //     statusOfCompliance: values?.statusOfCompliance,
        //     findingPhotographs: values?.findingPhotographs,
        //     compliancePhotographs: values?.compliancePhotographs
        // };
        const formData = new FormData();

        formData.append("ProjectId", projectId);
        formData.append(
            "DateTime",
            moment.utc(values?.dateTime, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss[Z]")
        );

        formData.append("EHSFinding", values?.ehsFinding);
        formData.append("ReportedBy", values?.reportedBy);
        formData.append("Severity", values?.severity);
        formData.append("Recommendation", values?.recommendation);
        formData.append("Area", values?.area);
        formData.append("Location", values?.location);
        formData.append(
            "ContractorSubContractorInvolved",
            values?.contractorSubContractorInvolved
        );
        formData.append("Category", values?.category);
        formData.append("PTWIssued", values?.ptwIssued ?? "");
        formData.append("PTWIssuedBy", values?.ptwIssuedBy);
        formData.append("StopWorkRecommended", values?.stopWorkRecommended ?? "");

        if (values?.targetClosureDate) {
            formData.append(
                "TargetClosureDate",
                moment
                    .utc(values?.targetClosureDate, "YYYY-MM-DD")
                    .format("YYYY-MM-DDTHH:mm:ss[Z]")
            );
        }

        formData.append("ActionOwner", values?.actionOwner);
        formData.append("ComplianceStatement", values?.complianceStatement);
        formData.append("VerifiedBy", values?.verifiedBy);
        formData.append("StatusOfCompliance", values?.statusOfCompliance);

        formData.append("Ageing", values?.ageing ?? 0);
        values?.findingPhotographs?.forEach((file) => {
            formData.append("FindingPhotographs", file);
        });

        values?.compliancePhotographs?.forEach((file) => {
            formData.append("CompliancePhotographs", file);
        });
        console.log("ews reqbody", formData)

        try {
            const response = await createEHSFinding(formData).unwrap();
            openNotification("EHS created successfully", "success");
            resetForm();
            setSubmitting(false);
            handleClose();
        } catch (error) {
            //  openNotification(error?.error ?? "Something went wrong", "error");
            console.log("API ERROR:", error);

            let errorMessage = "Something went wrong";

            if (error?.data?.errors) {
                errorMessage = Object.values(error.data.errors)
                    .flat()
                    .join(", ");
            } else if (error?.data?.title) {
                errorMessage = error.data.title;
            } else if (error?.error) {
                errorMessage = error.error;
            }

            openNotification(errorMessage, "error");
        } finally {
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleRemoveFindingsPhotographs = (index, setFieldValue, values) => {
        const updateImages = values.findingPhotographs.filter((item, imgIdx) => imgIdx !== index)
        setFieldValue("findingPhotographs", updateImages)
    }

    const handleRemoveCompliancePhotographs = (index, setFieldValue, values) => {
        const updateImages = values.compliancePhotographs.filter((item, imgIdx) => imgIdx !== index)
        setFieldValue("compliancePhotographs", updateImages)
    }

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add EHS
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    validate={validate}
                    onSubmit={handleSubmit}
                >
                    {({ values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                        setTouched, }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dateTime"
                                        value={values.dateTime}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.dateTime && errors.dateTime && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.dateTime}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>EHS Finding</Typography>
                                    <TextField
                                        fullWidth
                                        name="ehsFinding"
                                        value={values.ehsFinding}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter EHS Finding"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.ehsFinding && errors.ehsFinding && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ehsFinding}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Severity</Typography>
                                    <Select
                                        name="severity"
                                        options={severityOptions}
                                        value={severityOptions.find(opt => opt.value === String(values.severity)) || null}
                                        onChange={(option) => setFieldValue("severity", option.value)}
                                        onBlur={() => setFieldTouched("severity", true)}
                                        placeholder="Select Severity"
                                    />
                                    {touched.severity && errors.severity && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.severity}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>Recommendation</Typography>
                                    <TextField
                                        fullWidth
                                        name="recommendation"
                                        value={values.recommendation}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Recommendation"
                                        InputProps={{
                                            sx: {
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& textarea::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& textarea": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.recommendation && errors.recommendation && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.recommendation}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Reported By</Typography>
                                    <Select
                                        name="reportedBy"
                                        options={reportedByOptions}
                                        value={reportedByOptions.find(opt => opt.value === String(values.reportedBy)) || null}
                                        onChange={(option) => setFieldValue("reportedBy", option.value)}
                                        onBlur={() => setFieldTouched("reportedBy", true)}
                                        placeholder="Select Reported By"
                                    />
                                    {touched.reportedBy && errors.reportedBy && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.reportedBy}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Area</Typography>
                                    <TextField
                                        fullWidth
                                        name="area"
                                        value={values.area}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Area"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.area && errors.area && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.area}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Location</Typography>
                                    <TextField
                                        fullWidth
                                        name="location"
                                        value={values.location}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Location"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.location && errors.location && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.location}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Contractor & Sub Contractor Involved</Typography>
                                    <Select
                                        name="contractorSubContractorInvolved"
                                        options={contractorInvolvedOptions}
                                        value={contractorInvolvedOptions.find(opt => opt.value === String(values.contractorSubContractorInvolved)) || null}
                                        onChange={(option) => setFieldValue("contractorSubContractorInvolved", option.value)}
                                        onBlur={() => setFieldTouched("contractorSubContractorInvolved", true)}
                                        placeholder="Select Contractor & Sub Contractor Involved"
                                    />
                                    {touched.contractorSubContractorInvolved && errors.contractorSubContractorInvolved && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.contractorSubContractorInvolved}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Category</Typography>
                                    <Select
                                        name="category"
                                        options={categoryOptions}
                                        value={categoryOptions.find(opt => opt.value === String(values.category)) || null}
                                        onChange={(option) => setFieldValue("category", option.value)}
                                        onBlur={() => setFieldTouched("category", true)}
                                        placeholder="Select Category"
                                    />
                                    {touched.category && errors.category && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.category}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>PTW Issued</Typography>
                                    <Select
                                        name="ptwIssued"
                                        options={ptwIssuedOptions}
                                        value={ptwIssuedOptions.find(opt => opt.value === values.ptwIssued) || null}
                                        onChange={(option) => setFieldValue("ptwIssued", option.value)}
                                        onBlur={() => setFieldTouched("ptwIssued", true)}
                                        placeholder="Select PTW Issued"
                                    />
                                    {touched.ptwIssued && errors.ptwIssued && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ptwIssued}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>PTW Issued By</Typography>
                                    <TextField
                                        fullWidth
                                        name="ptwIssuedBy"
                                        value={values.ptwIssuedBy}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter PTW Issued By"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.ptwIssuedBy && errors.ptwIssuedBy && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.ptwIssuedBy}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Stop Work Recommended
                                    </Typography>
                                    <Select
                                        name="stopWorkRecommended"
                                        options={stopWorkOptions}
                                        value={stopWorkOptions.find(opt => opt.value === values.stopWorkRecommended) || null}
                                        onChange={(option) => setFieldValue("stopWorkRecommended", option.value)}
                                        onBlur={() => setFieldTouched("stopWorkRecommended", true)}
                                        placeholder="Select Stop Work Recommended"
                                    />
                                    {touched.stopWorkRecommended && errors.stopWorkRecommended && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.stopWorkRecommended}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Target Closure Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="targetClosureDate"
                                        value={values.targetClosureDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />
                                    {touched.targetClosureDate && errors.targetClosureDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.targetClosureDate}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Action Owner
                                    </Typography>
                                    <Select
                                        name="actionOwner"
                                        options={actionOwnerOptions}
                                        value={actionOwnerOptions.find(opt => opt.value === String(values.actionOwner)) || null}
                                        onChange={(option) => setFieldValue("actionOwner", option.value)}
                                        onBlur={() => setFieldTouched("actionOwner", true)}
                                        placeholder="Select Action Owner"
                                    />
                                    {touched.actionOwner && errors.actionOwner && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.actionOwner}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Compliance Statement</Typography>
                                    <TextField
                                        fullWidth
                                        name="complianceStatement"
                                        value={values.complianceStatement}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter Compliance Statement"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.complianceStatement && errors.complianceStatement && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.complianceStatement}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Verified By
                                    </Typography>
                                    <Select
                                        name="verifiedBy"
                                        options={verifiedByOptions}
                                        value={verifiedByOptions.find(opt => opt.value === String(values.verifiedBy)) || null}
                                        onChange={(option) => setFieldValue("verifiedBy", option.value)}
                                        onBlur={() => setFieldTouched("verifiedBy", true)}
                                        placeholder="Select Verified By"
                                    />
                                    {touched.verifiedBy && errors.verifiedBy && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.verifiedBy}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }} sx={{ zIndex: 3 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Status Of Compliance
                                    </Typography>
                                    <Select
                                        name="statusOfCompliance"
                                        options={statusOfComplianceOptions}
                                        value={statusOfComplianceOptions.find(opt => opt.value === String(values.statusOfCompliance)) || null}
                                        onChange={(option) => setFieldValue("statusOfCompliance", option.value)}
                                        onBlur={() => setFieldTouched("statusOfCompliance", true)}
                                        placeholder="Select Status Of Compliance"
                                    />
                                    {touched.statusOfCompliance && errors.statusOfCompliance && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.statusOfCompliance}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid container spacing={2} size={12}>
                                    <Grid size={6}>
                                        <Typography variant="subtitle2" mb={1} sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                            Finding Photographs
                                        </Typography>

                                        <Button variant="outlined" component="label" fullWidth>
                                            Upload
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files);
                                                    setFieldValue("findingPhotographs", [
                                                        ...values.findingPhotographs,
                                                        ...files
                                                    ]);
                                                }}
                                            />
                                        </Button>
                                        {errors.findingPhotographs && (
                                            <FormHelperText error>
                                                {errors.findingPhotographs}
                                            </FormHelperText>
                                        )}

                                        <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                            {values.findingPhotographs.map((file, index) => (
                                                <Box key={index} textAlign="center" sx={{ position: "relative" }}>
                                                    <img
                                                        src={URL.createObjectURL(file)}
                                                        alt="preview"
                                                        width={80}
                                                        height={80}
                                                        style={{ objectFit: "cover", borderRadius: 6 }}
                                                    />
                                                    <IconButton
                                                        onClick={() => handleRemoveFindingsPhotographs(index, setFieldValue, values)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 1,
                                                            right: 1,
                                                            p: 0,
                                                            backgroundColor: "rgba(0,0,0,0.6)",
                                                            color: "#fff",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(244,67,54,0.9)"
                                                            },
                                                            zIndex: 2
                                                        }}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>


                                    <Grid size={6}>
                                        <Typography variant="subtitle2" mb={1} sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                            Compliance Photographs
                                        </Typography>

                                        <Button variant="outlined" component="label" fullWidth>
                                            Upload
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files);
                                                    setFieldValue("compliancePhotographs", [
                                                        ...values.compliancePhotographs,
                                                        ...files
                                                    ]);
                                                }}
                                            />
                                        </Button>
                                        {errors.findingPhotographs && (
                                            <FormHelperText error>
                                                {errors.findingPhotographs}
                                            </FormHelperText>
                                        )}


                                        <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                            {values.compliancePhotographs.map((file, index) => (
                                                <Box key={index} textAlign="center" sx={{ position: "relative" }}>
                                                    <img
                                                        src={URL.createObjectURL(file)}
                                                        alt="preview"
                                                        width={80}
                                                        height={80}
                                                        style={{ objectFit: "cover", borderRadius: 6 }}
                                                    />
                                                    <IconButton
                                                        onClick={() => handleRemoveCompliancePhotographs(index, setFieldValue, values)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 1,
                                                            right: 1,
                                                            p: 0,
                                                            backgroundColor: "rgba(0,0,0,0.6)",
                                                            color: "#fff",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(244,67,54,0.9)"
                                                            },
                                                            zIndex: 2
                                                        }}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>

                                </Grid>

                                <Grid size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#F15744",
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "25px",
                                                fontWeight: 500,
                                                px: "20px",
                                                py: "15px",
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // loading={isLoading}
                                            sx={{
                                                backgroundColor: "#00344C",
                                                borderRadius: "25px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: "20px",
                                                py: "15px",
                                                display: "flex",
                                                gap: 1,
                                                "&.Mui-disabled": {
                                                    backgroundColor: "#00344C",
                                                    color: "#fff",
                                                    opacity: 0.7,
                                                },
                                            }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <CircularProgress size={16} color="inherit" />}
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddEHSFinding;